import { Hotkey } from "../types/hotkey";

export const match_hotkey = (key: String, metas: Array<String>, hotkeys: Array<Hotkey>) => {
    for (let hotkey of hotkeys) {
        if (metas.length < hotkey.metas.length)
            return null;
        for (let meta of metas) {
            if (!hotkey.metas.includes(meta))
                return null;
        }
        if (key == hotkey.key) {
            return hotkey;
        }
    }
    return null;
}